import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gauge',
  templateUrl: './gauge.component.html',
  styleUrls: ['./gauge.component.scss'],
})
export class GaugeComponent implements OnInit {
  values: number[] = [102, 115, 130, 137];

  public labels: any = {
    formatFunction: (value: number): string => {
      return value + ' h';
    },
    precision: 1,
    indent: 15,
  };

  tooltip: any = {
    visible: true,
    formatFunction: (value: string, i: number) => {
      let realVal = parseInt(value);
      return 'I: ' + i + '<br/>Price Index:' + realVal;
    },
  };

  constructor() {}

  ngOnInit() {}
}
